import { ApiInput } from './api-input';
import { ApiJobOutput } from './api-job-output';
import { ApiConversion } from './api-conversion';
import { ApiJobWarning } from './api-job-warning';
import { ApiJobError } from './api-job-error';
import { SerializeHelper } from '../serialize-helper';

class JobStatus {
    constructor(data) {
        /** @type ?String */
        this.code = data?.code ?? null;

        /** @type ?String */
        this.info = data?.info ?? null;
    }

    /**
     * Called by JSON.stringify to get a representation as a serializable object
     *
     * @return {Object}
     */
    toJSON() {
        return {
            code: this.code,
            info: this.info,
        };
    }
}

export { JobStatus };

class ApiJob {
    constructor(data) {
        /** @type ?String */
        this.id = data?.id ?? null;

        /** @type ?String */
        this.token = data?.token ?? null;

        /** @type {'job'} */
        this.type = data?.type ?? null;

        /** @type JobStatus */
        this.status = new JobStatus(data?.status);

        /** @type ApiJobError[] */
        this.errors = SerializeHelper.getArrayOfObject(data?.errors, ApiJobError);

        /** @type ApiJobWarning[] */
        this.warnings = SerializeHelper.getArrayOfObject(data?.warnings, ApiJobWarning);

        /** @type ?Boolean */
        this.process = data?.process ?? null;

        /** @type ?Boolean */
        this.failOnInputError = data?.fail_on_input_error ?? null;

        /** @type ?Boolean */
        this.failOnConversionError = data?.fail_on_conversion_error ?? null;

        /** @type ApiConversion[] */
        this.conversion = SerializeHelper.getArrayOfObject(data?.conversion, ApiConversion);

        /** @type Array */
        this.limits = data?.limits ?? [];

        /** @type ApiInput[] */
        this.input = SerializeHelper.getArrayOfObject(data?.input, ApiInput);

        /** @type ApiJobOutput[] */
        this.output = SerializeHelper.getArrayOfObject(data?.output, ApiJobOutput);

        /** @type ?String */
        this.callback = data?.callback ?? null;

        /** @type ?Boolean */
        this.notifyStatus = data?.notify_status ?? null;

        /** @type ?String */
        this.server = data?.server ?? null;

        /** @type ?Number */
        this.spent = SerializeHelper.getInteger(data?.spent);

        /** @type ?String */
        this.createdAt = data?.created_at ?? null;

        /** @type ?String */
        this.modifiedAt = data?.modified_at ?? null;

        /** @type ?String */
        this.apiEnv = data?.api_env ?? null;

        /** @type ?Object */
        this.sat = data?.sat ?? null;

        /** @type ?Object */
        this.satLinks = data?.sat_links ?? null;

        /** @type Object */
        this.rawJob = data?.raw_job ?? data;
    }

    /**
     * Called by JSON.stringify to get a representation as a serializable object
     *
     * @return {Object}
     */
    toJSON() {
        return {
            id: this.id,
            token: this.token,
            type: this.type,
            status: this.status,
            errors: this.errors,
            warnings: this.warnings,
            process: this.process,
            fail_on_input_error: this.failOnInputError,
            fail_on_conversion_error: this.failOnConversionError,
            conversion: this.conversion,
            limits: this.limits,
            input: this.input,
            output: this.output,
            callback: this.callback,
            notify_status: this.notifyStatus,
            server: this.server,
            spent: this.spent,
            created_at: this.createdAt,
            modified_at: this.modifiedAt,
            api_env: this.apiEnv,
            sat: this.sat,
            sat_links: this.satLinks,
            raw_job: this.rawJob,
        };
    }
}

export { ApiJob };
